import React from 'react'
import { Block, Button, TextArea } from '@mote/ui'
import copy from 'copy-to-clipboard'
import { useTrackMutation } from '@mote/api'
import styled from 'styled-components'
import { track as trackExtension } from 'plugin/src/shared/Analytics'

export const EmbedCodeBox = ({ url, onCopyEmbedCode, app }) => {
  const [value, setValue] = React.useState(
    `<div style="left: 0; width: 100%; height: 0; position: relative; padding-bottom: 100%;"><iframe src="${url}" style="top: 0; left: 0; width: 100%; height: 100%; position: absolute; border: 0;" title="Mote" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"></iframe></div>
    `
  )
  const { mutate: track } = useTrackMutation()

  async function handleCopyCode() {
    if (app === 'web') {
      await track({
        variables: {
          event: 'Mote Share Action Taken',
          action: 'Embed-code-copied'
        }
      })
    } else {
      trackExtension('Mote Share Action Taken', { action: 'Embed-code-copied' })
    }
    copy(value)
    onCopyEmbedCode()
  }

  return (
    <Block gap={20} align='flex-start'>
      <StyledTextarea
        rows={6}
        value={value}
        onChange={event => setValue(event.target.value)}
      />
      <Button text='Copy code' onClick={handleCopyCode} />
    </Block>
  )
}

const StyledTextarea = styled(TextArea)`
  padding: 16px;
`
